import { render, staticRenderFns } from "./privateBoard.vue?vue&type=template&id=0cf0ca9e&scoped=true&"
import script from "./privateBoard.vue?vue&type=script&lang=js&"
export * from "./privateBoard.vue?vue&type=script&lang=js&"
import style0 from "./privateBoard.vue?vue&type=style&index=0&id=0cf0ca9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf0ca9e",
  null
  
)

export default component.exports